import { useQueryClient } from '@tanstack/react-query'
import { ApiResponse } from '../../../types/api'
import { ChaptersInsertData } from '../../../types/chapters'
import { useApiPostMutation } from '../useApi'

export const useChaptersInsert = () => {
  const queryClient = useQueryClient()

  const mutation = useApiPostMutation<ApiResponse, ChaptersInsertData>()

  return {
    ...mutation,
    mutateAsync: async (data: ChaptersInsertData) => {
      const result = await mutation.mutateAsync({
        url: '/chapters/insert',
        data,
      })
      queryClient.invalidateQueries({ queryKey: ['chapterList'] })
      return result
    },
    mutate: (data: ChaptersInsertData) => {
      mutation.mutate(
        {
          url: '/chapters/insert',
          data,
        },
        {
          onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['chapterList'] })
          },
        }
      )
    },
  }
}
